(function(){
  "use strict";
  /* Le layout pose `no-js` sur <html>. On la retire ici : tant qu'elle est présente,
     la CSS rend tous les `.reveal` visibles. Si ce script ne se charge pas, rien ne
     reste caché. */
  document.documentElement.classList.remove('no-js');
  var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Révélations — RETIRÉES le 2026-09-24 à la demande de l'utilisateur.
        On pose l'état final (`in`) dès le chargement, pour tout le monde. La classe
        reste : c'est elle qui porte l'état visible, la retirer cacherait tout. */
  document.querySelectorAll('.reveal, .wipe').forEach(function(el){ el.classList.add('in'); });

  /* 2. Theme morph - bande de 0 px au centre du viewport.
        PAS threshold:0.5 : le chapitre épinglé fait 380vh et n'atteindrait jamais
        50 % de visibilité, le morph serait mort en silence. */
  var themed = document.querySelectorAll('[data-theme-section]');
  if ('IntersectionObserver' in window && themed.length){
    var to = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          document.documentElement.setAttribute('data-theme', e.target.dataset.themeSection);
        }
      });
    }, { rootMargin:'-50% 0px -50% 0px', threshold:0 });
    themed.forEach(function(el){ to.observe(el); });
  }

  /* 3. Damped scroll-progress. On lisse la LECTURE du scroll, jamais le scroll :
        aucun preventDefault, aucun overflow:hidden sur body. Barre native, inertie
        iOS, clavier et technologies d'assistance restent intacts. */
  var targetScroll = window.scrollY, smoothed = window.scrollY, DAMPING = 0.1;
  window.addEventListener('scroll', function(){ targetScroll = window.scrollY; }, { passive:true });

  function mapRange(v,inA,inB,outA,outB){
    var t=(v-inA)/(inB-inA); t = t<0?0:(t>1?1:t); return outA+(outB-outA)*t;
  }
  function progressOf(el,s){
    var start=el.offsetTop, end=start+el.offsetHeight-window.innerHeight;
    if (end<=start) return 0;
    var p=(s-start)/(end-start); return p<0?0:(p>1?1:p);
  }

  var chapter  = document.getElementById('mecanisme');
  var pivotImg = document.getElementById('pivotImg');
  var ghost90  = document.getElementById('ghost90');
  var heroImg  = document.getElementById('heroImg');

  /* Les enfants d'une scène épinglée ne peuvent pas s'appuyer sur l'IntersectionObserver :
     le conteneur sticky en overflow:hidden fausse le calcul (ratio 0 alors que l'élément
     est bien à l'écran). On les anime sur des sous-plages de la progression du chapitre. */
  var sceneEls  = chapter ? chapter.querySelectorAll('.scene-el')  : [];
  var sceneWipe = chapter ? chapter.querySelectorAll('.scene-wipe'): [];

  function paintScene(p){
    for (var i=0;i<sceneEls.length;i++){
      var el=sceneEls[i];
      var t=mapRange(p, parseFloat(el.dataset.from), parseFloat(el.dataset.to), 0, 1);
      el.style.opacity=t.toFixed(3);
      el.style.transform='translateY('+((1-t)*22).toFixed(2)+'px)';
    }
    for (var j=0;j<sceneWipe.length;j++){
      var w=sceneWipe[j];
      var tw=mapRange(p, parseFloat(w.dataset.from), parseFloat(w.dataset.to), 0, 1);
      w.style.clipPath='inset(0 0 '+((1-tw)*100).toFixed(2)+'% 0)';
    }
  }

  if (!motionOK){
    for (var k=0;k<sceneEls.length;k++){ sceneEls[k].style.opacity='1'; sceneEls[k].style.transform='none'; }
    for (var m=0;m<sceneWipe.length;m++){ sceneWipe[m].style.clipPath='none'; }
  }

  /* ------------------------------------------------------------------
     PANIER MOYEN
     Trois mécaniques, toutes en amélioration progressive : sans JavaScript,
     les paliers partent quand même avec la bonne quantité (des `radio` nommées
     `quantity`), l'ajout d'un accessoire fait un POST classique, et la barre
     collante reste simplement absente.
     ------------------------------------------------------------------ */

  /* 4. Paliers de quantité : rafraîchir le prix affiché.
        `data-total` porte le total EN CENTIMES calculé côté Liquid — on ne
        recalcule pas la remise ici, on réutilise le chiffre déjà affiché dans
        le palier, pour qu'il n'existe qu'une seule source de vérité. */
  var paliers = document.querySelectorAll('.paliers input[type="radio"]');
  var prixAffiche = document.querySelector('[data-kelvin-prix]');
  if (paliers.length && prixAffiche){
    paliers.forEach(function(radio){
      radio.addEventListener('change', function(){
        var label = radio.closest('.palier');
        var prix  = label && label.querySelector('.palier__prix');
        if (prix) prixAffiche.textContent = prix.textContent.trim();
      });
    });
  }

  /* 5. Ajout d'un accessoire sans quitter la page.
        Le formulaire reste un vrai formulaire : si fetch échoue, on le laisse
        partir en POST classique plutôt que d'avaler l'action de l'utilisateur. */
  document.querySelectorAll('form[data-kelvin-ajout]').forEach(function(form){
    form.addEventListener('submit', function(e){
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var libelle = btn ? btn.innerHTML : '';
      if (btn){ btn.disabled = true; btn.textContent = 'Ajout…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(form.querySelector('[name="id"]').value),
            quantity: Number(form.querySelector('[name="quantity"]').value || 1)
          }]
        })
      })
      .then(function(r){ if (!r.ok) throw new Error('ajout refusé'); return r.json(); })
      .then(function(){
        if (btn){ btn.textContent = 'Ajouté'; }
        /* L'en-tête écoute cet évènement pour rafraîchir son compteur. */
        document.dispatchEvent(new CustomEvent('cart:updated'));
        /* Sur la page panier, le contenu affiché est périmé : on recharge.
           Ailleurs, on laisse le visiteur où il est. */
        if (document.body.classList.contains('template-cart')) window.location.reload();
        else if (btn) setTimeout(function(){ btn.disabled = false; btn.innerHTML = libelle; }, 2200);
      })
      .catch(function(){
        if (btn){ btn.disabled = false; btn.innerHTML = libelle; }
        form.submit();
      });
    });
  });

  /* 6. Barre d'achat collante. Elle se retire quand le bloc d'achat est visible :
        deux appels à l'action concurrents sur le même écran s'annulent. */
  var barre = document.querySelector('[data-kelvin-barre]');
  if (barre){
    var cible = document.getElementById(barre.dataset.cible);
    var blocVisible = false;
    barre.hidden = false;

    var majBarre = function(){
      var passeHero = window.scrollY > (window.innerHeight * 0.85);
      barre.classList.toggle('is-visible', passeHero && !blocVisible);
    };

    if (cible && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        blocVisible = entries[0].isIntersecting;
        majBarre();
      }, { threshold: 0 }).observe(cible);
    }

    window.addEventListener('scroll', majBarre, { passive: true });
    majBarre();
  }

  function tick(){
    smoothed += (targetScroll - smoothed) * (motionOK ? DAMPING : 1);

    if (heroImg){
      var hp = mapRange(smoothed, 0, 760, 0, 1);
      heroImg.style.transform='translateY('+(hp*44).toFixed(2)+'px) scale('+(1-hp*.07).toFixed(3)+')';
      heroImg.style.opacity=(1-hp*.4).toFixed(3);
    }

    if (chapter && pivotImg){
      var p   = progressOf(chapter, smoothed);
      var rot = mapRange(p, .10, .88, 0, 34);
      var sc  = mapRange(p, 0, .6, .94, 1.04);
      pivotImg.style.transform='rotate('+rot.toFixed(2)+'deg) scale('+sc.toFixed(3)+')';
      /* Le « 90° » géant pivote à l'envers, deux fois plus vite : la scène respire. */
      if (ghost90){
        var g = mapRange(p, 0, 1, 12, -16);
        var gs= mapRange(p, 0, 1, .88, 1.06);
        ghost90.style.transform='rotate('+g.toFixed(2)+'deg) scale('+gs.toFixed(3)+')';
        ghost90.style.opacity=mapRange(p, 0, .18, 0, 1).toFixed(3);
      }
      paintScene(p);
    }
    requestAnimationFrame(tick);
  }
  /* Arrêt de la boucle morte, corrigé le 2026-09-14. `tick()` se
     réordonnançait indéfiniment même quand `heroImg` et `chapter`
     n'existaient plus — c'est-à-dire sur TOUTES les pages depuis
     l'abandon du gabarit électroménager. Une rAF permanente empêche le
     thread principal de se mettre au repos : batterie, et INP dégradé.
     La boucle ne démarre que si une de ses cibles est réellement dans
     la page. Le reste de ce script (no-js, paliers, ajout, barre collante)
     continue de s'exécuter normalement. */
  if (motionOK && (heroImg || chapter)) requestAnimationFrame(tick);
})();
